(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  function scrollToHash(targetHash) {
    if (!targetHash) return;
    const id = decodeURIComponent(targetHash.slice(1));
    const el = document.getElementById(id);
    if (el) {
      // 'auto' = instant; use 'smooth' if you want animation
      el.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' });
    }
  }

  // On initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scrollToHash(window.location.hash), { once: true });
  } else {
    // Run on next frame to ensure layout is ready
    requestAnimationFrame(() => scrollToHash(window.location.hash));
  }

  // Optional: also respond to hash changes without page reload
  window.addEventListener('hashchange', () => scrollToHash(window.location.hash));
})();

  } catch(e) { console.error(e); }
})();
})();
